// 选择采购单号
import React from 'react'
import { connect } from 'react-redux'
import {
    addListItem, changeListItem, deleteListItem, getListFromValues,
    hasChangedValues, getFormValue, changeItemsValue, nullDate, getListIds, getMergedValues
} from '../../public/utility'
import RequisitionDiv from 'tyan/menus/PurchaseManageMent/RequisitionDiv'
import PurchaseDiv from 'tyan/menus/PurchaseManageMent/PurchaseDiv'

class SelectPurchaseOrderNoDiv extends React.Component {
    state = {
        orderNo: this.props.initValues && this.props.initValues.orderNo || '',
        bReadOnly: this.props.initValues && this.props.initValues.bReadOnly || false ,
        onlyView: this.props.onlyView
    }

    componentDidMount = () => {
        this.doGetPurchaseOrderNoInfo()
    }

    doGetPurchaseOrderNoInfo = (searchString = '') => {
        const { orderNo ,bReadOnly} = this.state
        Tyan.doPostEvent('GetPurchaseOrderNoList', {
            data: {
                search: searchString,
                orderNo,
                bReadOnly
            },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息, items采购单号 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ initValues基本信息, optionsParas, changedValues基本信息: {}, items采购单号 })
                }
            }
        })
    }

    handlerSave = () => {
        const { onConfirm, onClose } = this.props
        let objNewJson = getMergedValues(this, '基本信息')
        const { list } = getListFromValues('采购单号', objNewJson, {})

        // const { list } = getListFromValues('采购单号', '', null, changedValues基本信息)
        // if (list.length > 1) {
        //     Tyan.pubForm.showError('只能选一条记录')
        //     return
        // }
        
        var i = 0
        let name = ''
        for (i = 0; i < list.length; i++) {
            if (i < list.length - 1)
                name = name + list[i].采购单号 + ','
            else
                name = name + list[i].采购单号
        }
        onConfirm && onConfirm(name)
        onClose && onClose()
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }

    handlerGetRequisition = (id) => {

        Tyan.pubForm.showDialog('采购信息', props => <PurchaseDiv {...props} id={id} />)

    }

    fieldset基本信息 = () => {
        const { items采购单号,bReadOnly,onlyView } = this.state
        return [
            {
                _checkgrid: '', name: '采购单号', rowNumbers: false, minRows: 15, margin: "5px 10px 5px 10px", minWidth: '90%',
                itemsValues: items采购单号, onSearch: this.doGetPurchaseOrderNoInfo,
                columns: [
                    { _text: '采购单号', minWidth: 200, flex: 1, },
                    { _text: '供应商名称', minWidth: 300, flex: 1 },
                    { _float: '金额', minWidth: 100, flex: 1 },
                    {
                        _buttons: [
                            {
                                _button: '查看', icon: 'info-circle', ui: '', margin: 0,
                                handler: ({ showDetail, refreshPage }, data) => this.handlerGetRequisition(data.id),
                                cdt:() => !onlyView
                            },
                        ], width: 100, margin: 0,
                    },
                ],
            }]
    }

    render() {
        const { showMessage: Message, showBody: Body, } = this.props
        const { errorMessage, initValues基本信息, changedValues基本信息 ,bReadOnly} = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="1000"
            controls={
                bReadOnly?[
                { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
            ]:
                [
                
                        { _button: '确定', icon: 'save', handler: this.handlerSave, disabled: !this.bChanged() },
                        { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                 
                ]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: bReadOnly },
                ]}
        />
    }
}

export default connect()(SelectPurchaseOrderNoDiv)